import * as telemetry from "../telemetry";
import { parse } from "query-string";

export function inIframe(): boolean {
  return window.self !== window.top;
}

export function getParameterByName(
  name: string,
  searchString?: string
): string | null {
  if (!searchString) {
    searchString = "?" + window.location.href.split("?")[1];
  }
  const value = parse(searchString, { decode: false })[name] || null;
  if (Array.isArray(value)) {
    return value[0];
  } else {
    return value;
  }
}

export function getBusinessId(): string {
  return (
    getParameterByName("businessId") || localStorage.getItem("businessId") || ""
  );
}

export function saveBusinessId(): void {
  const businessId = getParameterByName("businessId");

  if (businessId) {
    localStorage.setItem("businessId", businessId);
  }
  const existingBusinessId = getBusinessId();
  if (existingBusinessId !== "") {
    telemetry.group(existingBusinessId);
  }
}
export const removeQueryString = (origin: string): string => {
  let url: URL;
  try {
    url = new URL(origin);
  } catch {
    return "";
  }
  return url.origin + url.pathname;
};
